// common data retrievers

import SecondServer from '../database/SecondServer'
import {apiFormat} from '../timeFunctions/timeFns'
import {urlSiteReadings, urlPermission} from '../database/apiUrls'
import {siteAccessCode} from '../database/apiv2SiteAccessor'

export async function fetchHistoricalSiteData(siteId, from, to, ss) {
  const endrange = fixupDate(to);
  let startrange = fixupDate(from);
  if (false === isDatable (from))
    startrange.setTime(endrange.getTime() - 24*3600 * 1000); 
  
  return await promiseHistoricalSiteData(siteId, startrange, endrange, ss);
}
export async function promiseHistoricalSiteData(siteId, from, to, ss, type='SensorData') {
  const limit = Math.abs(from - to) / 10000  // 360 readings per hour
  const url = urlSiteReadings(siteId, apiFormat(from), apiFormat(to), limit, type)
  return ss.apiDataObj(url);
}
export async function fetchPerms(props) {
  const ss = new SecondServer(props);
  const siteId = siteAccessCode(props.getActiveSite());
  if (siteId)
    return await promisePerms(ss, siteId)
  else
    return {resp:{result:{outcome:'fail'}}}
}
export async function promisePerms(ss, siteId) {
  return ss.apiInsertData (urlPermission(siteId), null);
}
export async function fetchNetworkStatus (siteId, from, to, ss, limit=12000) {
  const url = urlSiteReadings(siteId, apiFormat(from), apiFormat(to), limit, 'NetworkData')
  const data = await ss.apiDataObj (url);
  fixupRssiArray(data?.jsonResponse?.data?.data?.raw_data)  // mutates array
  return data
}
export function fixupRssiArray(arrData) {
  if (Array.isArray(arrData)) {
    return arrData.map((item) => {
      item.FarEndRssi = item?.FarEndRssi ? Math.max(item.FarEndRssi -38, 0) : item?.FarEndRssi
      return item
    })
  }
}
function fixupDate (param) {
  const retcode = isDatable (param);
  return retcode ? retcode : new Date();
}

// return a date object or false if param is no date.
export function isDatable(param) {
  var p2 = param;
  if (typeof param === 'string')
    p2 = new Date(param);

  if(typeof p2 === 'object') {
    if (p2.getTime && false === isNaN(p2.getTime()))
      return p2;
  }
  return false;
}
